import React, { useMemo } from 'react';
import { useUserEntity } from '../../hooks/useUserEntity';

export const UserAccessWrapper = ({
  children,
  exposeToUser,
}: {
  children: React.ReactNode;
  exposeToUser?: 'external' | 'internal';
}) => {
  const userEntity = useUserEntity();
  const isExternalUser = useMemo(() => {
    return Boolean(
      userEntity?.value?.metadata?.annotations?.['backstage.io/managed-by-location']?.includes('/external/'),
    );
  }, [userEntity?.value]);
  
  if (userEntity.loading) {
    return <></>;
  }

  if (isExternalUser && exposeToUser === 'external') {
    return <>{children}</>;
  }
  
  if (!isExternalUser && exposeToUser === 'internal') {
    return <>{children}</>;
  }
  
  return <></>;
};
